// let interval;

// interval = setInterval(function () {
//   if (typeof jQuery !== "undefined") {
//     clearInterval(interval);
//     init();
//   }
// }, 1000);

// document.addEventListener("DOMContentLoaded", function () {
//   init();
// });

let __didInit = false;

function runInitWhenJqueryReady() {
  if (__didInit) return;

  if (window.jQuery) {
    __didInit = true;
    init();
  } else {
    setTimeout(runInitWhenJqueryReady, 100);
  }
}

document.addEventListener("DOMContentLoaded", runInitWhenJqueryReady);

const init = function () {
  const tab_labels = $(".featured-collection-tab-labels > div");
  const tab_contents = $(".featured-collection-tab-contents > div");

  $(document).on(
    "click",
    ".featured-collection-tab-labels > div",
    function (e) {
      const label = $(e.target);
      const contents = label
        .parents(".featured-collection-tabs")
        .find(".featured-collection-tab-contents > div");
      const index = $(this).index();
      const content = $(contents[index]);
      label.addClass("active").siblings().removeClass("active");
      content.addClass("active").siblings().removeClass("active");
    });

  //   $(document).on("click", ".need-help", function () {
  //   const element = document.querySelector("inbox-online-store-chat");
  //   const shadowRoot = element.shadowRoot;
  //   const buttonInShadowDom = shadowRoot.querySelector(".chat-toggle");

  //   $(buttonInShadowDom).click();
  // });
};

 

var TabSizeFit = class extends HTMLElement {
  constructor() {
    super();
    this.style.display = "none";
    this._getData();
    this.style.display = "block";
  }
  _getData() {
    //const string = this.innerHTML;
    const string = (this.textContent || "").trim();
    if (!string) {
      document.querySelector('.custom-desc .size-fit').remove();
      return false;
    }


    let data;
  try {
    // ✅ parse safely
    data = JSON.parse(string);
  } catch (e) {
    console.error("[TabSizeFit] JSON parse failed:", e, string);

    // ✅ avoid blank drawer: show a simple fallback OR hide it
    this.innerHTML = `<div class="size-fit-header"><div>Size chart unavailable</div></div>`;
    return false;
  }
    //const data = JSON.parse(string);
    const titleItem = data.filter((i) => i.title)[0];
    const imageItem = data.filter((i) => i.image)[0];
    const attrItems = data.filter((i) => !i.image && !i.title);

    let titleDom = "";
    let textsDom = "";
    for (const key in titleItem) {
      if (key === "title") {
        titleDom += `
          <div>${titleItem[key]}</div>
        `;
      } else {
        textsDom += `
          <div><strong>${key}: </strong>${titleItem[key]}</div>
        `;
      }
    }
    titleDom = `
      <div class="size-fit-header">${titleDom}<div>${textsDom}</div></div>
    `;

    let imagesDom = `<img src="${imageItem.image}">`;

    let trsDom = "";
    for (const key in attrItems[0]) {
      trsDom += `
          <th>${key}</th>
        `;
    }

    let attrsDom = "";
    attrItems.forEach((item) => {
      let lines = "";
      for (const key in item) {
        lines += `
          <td>${item[key]}</td>
        `;
      }
      attrsDom += `<tr>${lines}</tr>`;
    });
    attrsDom = `<table class="size-fit-table">${trsDom}${attrsDom}</table>`;
    this.innerHTML = titleDom + imagesDom + attrsDom;
  }
};
if (!window.customElements.get("tab-size-fit")) {
  window.customElements.define("tab-size-fit", TabSizeFit);
}

var TabSpecs = class extends HTMLElement {
  constructor() {
    super();
    this.style.display = "none";
    this._getData();
    this.style.display = "block";
  }
  _getData() {
    const string = this.innerHTML;
    if (!string) {
      document.querySelector('.custom-desc .spec').remove();
      return false;
    }
    const data = JSON.parse(string);

    let attrsDom = "";
    let text = "";
    for (const key in data) {
      if (key.indexOf("group") > -1) {
        attrsDom += `
        <tr class="group-title">
        	<td colspan="2">${data[key]}</td>
        </tr>
      `;
      } else if (key === "Technical Overview") {
        text = data[key];
      } else {
        attrsDom += `
        <tr>
          <td>${key}</td>
          <td>${data[key]}</td>
        </tr>
      `;
      }
    }
    attrsDom = `
      <table class="specs-table">${attrsDom}</table>
    `;
    if(text !== '') {
      attrsDom += `
        <div>
          <h5 class="h5">Technical Overview</h5>
          <div>${text}</div>
        </div>
      `
    }
    this.innerHTML = attrsDom;
  }
};
if (!window.customElements.get("tab-specs")) {
  window.customElements.define("tab-specs", TabSpecs);
}
